window.addEventListener('DOMContentLoaded', (event) => {
    const textareas = document.querySelectorAll("[data-textarea-word-count]");
    // counter for the number of textfields that need to be validated before the submit button is enabled
    let textareas_enable_count = 0;

    textareas.forEach(textarea => {
        const min_word_count = textarea.dataset.textareaWordCountMin;
        const disable_button_selector = textarea.dataset.textareaWordCountDisableButton;

        // disable button onload if a selector is set and if there is a minimum word count
        if (disable_button_selector && min_word_count) {
            document.querySelector(disable_button_selector).disabled = true;
            textareas_enable_count++;
        }

        textarea.addEventListener('input', wordCount);
    });

    function wordCount() {

        const disable_button_selector = this.dataset.textareaWordCountDisableButton;
        const display_word_count_selector = this.dataset.textareaWordCountDisplay;
        let min_word_count = this.dataset.textareaWordCountMin;
        let max_word_count = this.dataset.textareaWordCountMax;

        // if no min count is set, set it to 0
        if (!min_word_count) {
            min_word_count = 0;
        }

        // if not max word count is set, set it to -1
        if (!max_word_count) {
            max_word_count = -1;
        }

        if (disable_button_selector) {
            document.querySelector(disable_button_selector).disabled = true;
        }

        /**
         * this.value       - gets the value of the textarea (i.e. the string)
         * .trim()          - removes any whitespace at the start or end of the string
         * .replace(/[\t\n\r\.\?\!]/gm, "\s") - replace tabs and new lines etc with a space
         * .split(/\s+/)    - divides the string around every space and puts them into an array
         * .filter(Boolean) - skips any blank values in the array - i.e. those created by double spacing
         * .length          - gets the length of the array (i.e. how many words there are)
         */
        let word_count = this.value.trim().replace(/[\t\n\r\.\?\!]/gm, "\s").split(/\s+/).filter(Boolean).length;
        
        if (display_word_count_selector) {
            document.querySelector(display_word_count_selector).innerText = word_count;
        }

        if (disable_button_selector) {
            if (word_count >= min_word_count && (max_word_count == -1 || word_count <= max_word_count)) {
                this.dataset.textareaWordCountValidated = true;
            } else {
                this.dataset.textareaWordCountValidated = false;
            }

            // if all textarea fields are validated to contain the right amount of words, enable the submit button
            if (document.querySelectorAll('[data-textarea-word-count-validated="true"]').length == textareas_enable_count) {
                document.querySelector(disable_button_selector).disabled = false;
            }
        }
    }
});

